var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 3.27273C24 1.46525 22.5348 0 20.7273 0H3.27273C1.46525 0 0 1.46525 0 3.27273V20.7273C0 22.5348 1.46525 24 3.27273 24H20.7273C22.5348 24 24 22.5348 24 20.7273V3.27273ZM21.8182 3.27273C21.8182 2.67024 21.3298 2.18182 20.7273 2.18182H3.27273C2.67024 2.18182 2.18182 2.67024 2.18182 3.27273V20.7273C2.18182 21.3298 2.67024 21.8182 3.27273 21.8182H20.7273C21.3298 21.8182 21.8182 21.3298 21.8182 20.7273V3.27273Z",
    fill: "#363636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29286 18.2166L8.92906 9.53206C9.33626 8.76931 10.4082 8.76931 10.8154 9.53206L14.2195 15.9087L15.3855 13.824C15.7979 13.0865 16.8385 13.0865 17.2509 13.824L19.6971 18.1977C20.1063 18.9295 19.5891 19.84 18.7642 19.84H5.236C4.42052 19.84 3.90236 18.9481 4.29286 18.2166Z",
    fill: "#363636"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5601 7.68C18.5601 8.91712 17.5572 9.92 16.3201 9.92C15.0829 9.92 14.0801 8.91712 14.0801 7.68C14.0801 6.44288 15.0829 5.44 16.3201 5.44C17.5572 5.44 18.5601 6.44288 18.5601 7.68Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIcon);
export default __webpack_public_path__ + "static/media/media-icon.9dcfccb757956a364c272b398101366b.svg";
export { ForwardRef as ReactComponent };